import { render, staticRenderFns } from "./fhir-address.vue?vue&type=template&id=a2b0f154&"
import script from "./fhir-address.vue?vue&type=script&lang=js&"
export * from "./fhir-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports